import { Pipe, PipeTransform } from '@angular/core';
import { RpaDto, RpaDetailsDto } from '@flyfreely-portal-ui/flyfreely';

@Pipe({ name: 'formatRpa' })
export class FormatRpaPipe implements PipeTransform {
    transform(rpa: RpaDto | RpaDetailsDto) {
        if (!rpa) {
            return null;
        }
        if (rpa.isDummy) {
            return `${rpa.nickname} (dummy)`;
        }

        return rpa.nickname;
    }
}
